var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { backgroundColor } from '../utils/theme';
var Background = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  width: 100%;\n  min-height: '100%';\n"], ["\n  ", "\n  ", "\n  width: 100%;\n  min-height: '100%';\n"])), function (props) { return props.color && "background-color: ".concat(function (props) { return backgroundColor(props); }, " "); }, function (props) { return props.adColor && "background-color: ".concat(props.adColor); });
export default Background;
var templateObject_1;
